import { WebsiteCode } from 'projects/vacation-forestage/src/environments/model';

import { ThemeConfig } from './theme-config/theme-config.model';
import { THEME as VACATION_THEME } from './theme-config/theme.yeaAndVacation';

export const MAP_WEBSITE_CODE_TO_THEME: Record<WebsiteCode, ThemeConfig> = {
  YesAndVac: VACATION_THEME,
};
